import React from 'react';
import Logo from '../../assets/miporis.jpg';

function Footer() {
    return (
        <footer className="py-16 px-6 border-t border-gray-100 bg-white">
            <div className="max-w-[1200px] mx-auto flex flex-col md:flex-row justify-between items-center gap-10">
                <div className="flex items-center gap-3">
                    <a href='/' className="flex items-center cursor-pointer transition-opacity hover:opacity-80">
                        <img src={Logo} className="h-6" alt="MIPORIS Logo" />
                    </a>
                </div>
                <div className="flex gap-10 text-sm font-semibold text-gray-500">
                    <a className="hover:text-[#0077C8] transition-colors" href="/privacy-policy">Privacy</a>
                    <a className="hover:text-[#0077C8] transition-colors" href="/terms-and-conditions">Legal</a>
                    <a className="hover:text-[#0077C8] transition-colors" href="/contact">Contact</a>
                </div>
                <p className="text-sm text-gray-400">© 2024 Miporis Assurance Ltd.</p>
            </div>
        </footer>
    );
}

export default Footer;
